import { useStore } from 'vuex' // or your specific import path for the store
import { defineNuxtPlugin, useRouter } from '#app'

/*
 * A little plugin to make navigation make sense:
 * for SECONDARY NAVIGATION @see components/secondary-nav/SecondaryNav.vue
 * reset the state on page navigation - we don't want to keep the secondary nav open
 * when the user navigates to a different page.
 */

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const store = useStore()

  const getCurrentHistoryPosition = () => {
    if (typeof window === 'undefined') return null

    return typeof window.history.state?.position === 'number'
      ? window.history.state.position
      : null
  }

  if (typeof window !== 'undefined') {
    store.commit('applicationModule/HISTORY_RESET', {
      page: router.currentRoute.value.fullPath,
      position: getCurrentHistoryPosition(),
    })
  }

  router.afterEach((to, from) => {
    if (typeof window !== 'undefined' && to.fullPath !== from.fullPath) {
      store.commit('applicationModule/HISTORY_ADD', {
        page: to.fullPath,
        position: getCurrentHistoryPosition(),
      })
    }

    // Only modify navigation state if path is changing (not just query params)
    if (to.path !== from.path) {
      // Only disable it until the page specifies that it's enabled
      // Don't hide the nav - let the middleware handle visibility based on localStorage
      store.commit(
        'secondaryNavigationModule/SET_IS_SECONDARY_NAVIGATION_ENABLED',
        false,
      )
    }
  })
})
